import { apiClient } from '@app/api';
import { parseRangeFromTs, toTimestamp } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../stores/stream-screen.store';
import AdoverlayView from './AdoverlayView';
import { filterAdoverlayData, formatAdoverlayData } from './utils';
import { Station } from '@app/core/types/stations';

interface IAdoverlayContainer {
  station: Station;
}

const AdoverlayContainer: React.FunctionComponent<IAdoverlayContainer> = (props) => {
  const { station } = props;
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const range = parseRangeFromTs(debouncedFocus);

  const { data, isLoading } = useQuery({
    queryKey: ['adoverlay', station.slug, range.from, range.to],

    queryFn: () =>
      apiClient.audit
        .fetchAdoverlayRange(
          station.slug,
          {
            from: toTimestamp(range.from),
            to: toTimestamp(range.to),
          },
          true,
        )
        .then((res) => formatAdoverlayData(filterAdoverlayData(res))),
  });

  return <AdoverlayView data={data} loading={isLoading} station={station} />;
};

export default AdoverlayContainer;
